export const filterFromString = (search: string): { [key: string]: any } | null => {
    const filter: { [key: string]: any } = {}
    const replaced = search.replace('?', '')
    const splited = replaced.split('&')

    splited.forEach(i => {
        const splited = i.split('=')
        const key = splited[0]
        const value = splited[1]

        if (key === undefined || key === 'undefined' || value === undefined || value === 'undefined' || value === '') return
        else if (key === 'isDeleted') filter[key] = value
        else if (key.toLowerCase().includes("search")) filter[key] = decodeURI(value)
        else if (key.toLowerCase().includes("limit")) filter[key] = parseInt(value, 10)
        else if (key.toLowerCase().includes("offset")) filter[key] = parseInt(value, 10)
        else if (key === 'idCompany') filter[key] = parseInt(value, 10)
        else if (key === 'idObjectGroup') filter[key] = parseInt(value, 10)
        else if (key === 'idObject') filter[key] = parseInt(value, 10)
        else if (key === 'idDevice') filter[key] = parseInt(value, 10)
        else if (key === 'idGroup') filter[key] = parseInt(value, 10)
        else if (key === 'idUser') filter[key] = parseInt(value, 10)
        else if (key === 'idUserType') filter[key] = parseInt(value, 10)
        else if (key === 'idUserGroup') filter[key] = parseInt(value, 10)
        else if (key.toLowerCase().includes("datefrom") || key.toLowerCase().includes("dateto"))
        {
            filter[key] = decodeURI(value)
        }
        else filter[key] = value
    })

    if (Object.entries(filter).length > 0) return filter
    else return null
}
